const isHTML = (string) => /<\/?[a-z][\s\S]*>/i.test(string);
export default isHTML;
